<template>
	<el-main>
		<el-row>
			<el-col :span="24">
				<div class="grid-content bg-purple-dark">
					<h2>订单信息</h2>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<div class="grid-content bg-purple">
					<h1>方案名称:{{orderEnt.OrderName}}</h1>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="12">
				<div class="grid-content bg-purple">
					<h1>提交时间：{{orderEnt.CommitDate}}</h1>
				</div>
			</el-col>
			<el-col :span="12">
				<div class="grid-content bg-purple-light">
					<h1>审核时间：{{orderEnt.ApproveDate}}</h1>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<div class="grid-content bg-purple">
					<h1>方案备注：{{orderEnt.Memo}}</h1>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<div class="grid-content bg-purple-dark">
					<h2>项目信息</h2>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24" style="text-align: left;">
				<div class="grid-content bg-purple" v-for="(Item, Index) in groupList" :key='Index'>

					<el-row>
						<h2>项目分组：[{{Item.GroupName}}][适用性别：{{Item.Sex}}][年龄：{{Item.MinAge}}-{{Item.MaxAge}}][婚否：{{Item.Marry}}]</h2>

					</el-row>
					<el-row>
						<div v-for="(gItem, gIndex) in groupitemList" :key='gIndex'>

							<h1 v-if="gItem.GroupID==Item.GroupID">
								{{gItem.SaleModuleName}}
							</h1>
							<p v-if="gItem.GroupID==Item.GroupID">[原价:{{gItem.OrgPrice}}][售价:{{gItem.CurPrice}}][折扣:{{gItem.Discount}}]
								<br>医学解释：{{gItem.FNote}}</p>
						</div>
					</el-row>
				</div>
			</el-col>
		</el-row>
	</el-main>

</template>

<script>
	import es from '../../commontools/enums.js'
	import ordergroup from '../../apifunction/OrderGroup.js'
	import groupitem from '../../apifunction/GroupItem.js'
	import explain from '../../apifunction/SalemoduleExplain.js'
	// import pdf from '../../commontools/htmlToPdf.js'
	// const echarts = require('echarts');
	export default {
		created: function() {
			this.initexplain();
			// this.initData();
		},
		watch: {
			// 如果路由发生变化，再次执行该方法
			"$route": "initData"
		},
		data() {
			return {
				orderEnt: null,
				groupList: null,
				groupitemList: null,
				explainList: []
			};
		},
		methods: {
			initexplain: function() {
				var ent = this.$route.query.ent;
				this.orderEnt = JSON.parse(ent);
				this.initSaleModuleExplain(this.orderEnt.CommitCorpID);
				//let user = JSON.parse(JSON.stringify(this.myglobal.userinfo));
				// explain.GetSaleModuleExplainAll(this.orderEnt.CommitCorpID)
				// 	.then(res => {
				// 		let ent = JSON.parse(JSON.stringify(res.data))
				// 		if (ent.Flag == 'success') {
				// 			this.explainList = JSON.parse(ent.Data);
				// 			this.initData();
				// 		} else
				// 			this.$message.info(ent.Msg);
				// 	})
			},
			initSaleModuleExplain(corpid) {
				if (this.explainList.length < 1) {
					explain.GetSaleModuleExplainAll(corpid)
						.then(res => {
							let ent = JSON.parse(JSON.stringify(res.data))
							if (ent.Flag == 'success') {
								this.explainList = JSON.parse(ent.Data);
								this.initData();
							} else
								this.$message.info(ent.Msg);
						})
				} else {
					if (this.explainList[0].CorpID != corpid) {
						explain.GetSaleModuleExplainAll(corpid)
							.then(res => {
								let ent = JSON.parse(JSON.stringify(res.data))
								if (ent.Flag == 'success') {
									this.explainList = JSON.parse(ent.Data);
									this.initData();
								} else
									this.$message.info(ent.Msg);
							})
					}
				}

			},
			initData() {
				var ent = this.$route.query.ent;
				this.orderEnt = JSON.parse(ent);
				this.initSaleModuleExplain(this.orderEnt.CommitCorpID);
				ordergroup.GetOrderGroupData(this.orderEnt.OrderID)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.groupList = JSON.parse(ent.Data);
							for (var i = 0; i < this.groupList.length; i++) {
								this.groupList[i].Sex = es.GetEnumNameByValue(es.AdaptSex, this.groupList[i].Sex);
								this.groupList[i].Marry = es.GetEnumNameByValue(es.AdaptMarry, this.groupList[i].Marry);
							}
						} else
							this.$message.info(ent.Msg);
					})
				groupitem.GetGroupItemDataByOrder(this.orderEnt.OrderID)
					.then(res => {
						let ent = JSON.parse(res.data)
						if (ent.Flag == 'success') {
							//alert(JSON.stringify(this.explainList))

							this.groupitemList = JSON.parse(JSON.stringify(ent.Data));
							for (let i = 0; i < this.groupitemList.length; i++) {
								var temp = this.explainList.find(itm => {
									if (itm.SaleModuleID == this.groupitemList[i].SaleModuleID)
										return itm;
								})
								this.groupitemList[i].FNote = '';
								//alert(temp)
								if (temp != null) {
									this.groupitemList[i].FNote = temp.FNote;

								}
							}
						} else
							this.$message.info(ent.Msg);
					})
			}
			// initCharts() {
			// 	var myChart = echarts.init(this.$refs.chart);
			// 	// 绘制图表
			// 	myChart.setOption({
			// 		title: {
			// 			text: '在Vue中使用echarts'
			// 		},
			// 		tooltip: {},
			// 		xAxis: {
			// 			data: ["衬衫", "羊毛衫", "雪纺衫", "裤子", "高跟鞋", "袜子"]
			// 		},
			// 		yAxis: {},
			// 		series: [{
			// 			name: '销量',
			// 			type: 'bar',
			// 			data: [5, 20, 36, 10, 10, 20]
			// 		}]
			// 	});
			// }
		},
		mounted() {
			// this.initCharts();
			// this.initData();
		}
	}
</script>

<style>
	.el-row {
		margin-bottom: 20px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.el-col {
		border-radius: 4px;
	}

	.bg-purple-dark {
		background: #99a9bf;
	}

	.bg-purple {
		background: #d3dce6;
	}

	.bg-purple-light {
		background: #e5e9f2;
	}

	.grid-content {
		border-radius: 4px;
		min-height: 36px;
	}

	.row-bg {
		padding: 10px 0;
		background-color: #f9fafc;
	}
</style>
